// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609210034/js/" + chunkId + "." + {"44":"c8cd0a47","225":"f4d6312b","481":"6b139372","486":"1630bc26","770":"4caabe63"}[chunkId] + ".0.2998266999890029.chunk.js";
};